import {Component, EventEmitter, Input, Output} from '@angular/core';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import {DisplayIdentifier} from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import Article from '../../../smoothr-web-app-core/models/Article';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {OrderType} from '../../../smoothr-web-app-core/enums/OrderType';
import {
	getAvailability,
	getBasePrice,
	getPrice,
	numberD,
	numberToCurrency
} from '../../../smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-article-option-group-single',
	templateUrl: './article-option-group-single.component.html',
	styleUrls: ['article-option-group-single.component.scss']
})
export class ArticleOptionGroupSingleComponent {
	@Input() optionGroup: OptionGroup;
	@Input() selected: ArticleOption[];
	@Input() article: Article;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Output() openInfo = new EventEmitter<Article>();
	@Input() preorderType: PreorderType;
	@Input() currency: string;
	selectedItem: Article;
	numberToCurrency = numberToCurrency;
	getBasePrice = getBasePrice;
	di = DisplayIdentifier;
	ot = OrderType;
	pricesMap = new Map<string, number>();

	constructor() {}

	isHidden(article: Article): boolean {
		return this.preorderType && !getAvailability(article, OrderType.PREORDER, this.preorderType);
	}

	selectedOptionIndex() {
		const indexSelection = this.selected.findIndex(selectedOption => selectedOption.group === this.optionGroup._id);
		if (indexSelection < 0) {
			return indexSelection;
		}
		return this.optionGroup.articles.findIndex(article => article._id === this.selected[indexSelection].article._id);
	}

	onSelectionChange(article: Article) {
		this.selectedItem = article;
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroup._id;
		articleOption.quantity = 1;
		this.selection.emit(articleOption);
		console.log(this.selectedItem, article);
	}

	isDisabled(option: Article): boolean {
		return option.requirements && option.requirements.min > 0 && this.isOptionSelected(option);
	}

	price(option: Article): string {
		this.likeSotCalulation(option);

		if (
			this.optionGroup &&
			this.optionGroup.tags.some(tag => tag.identifier === 'is_main_article') &&
			this.optionGroup.tags.some(tag => tag.identifier === 'replaces_main_article') &&
			this.optionGroup.displayIdentifiers.includes(DisplayIdentifier.hot_beverages)
		) {
			return '';
		}
		if (this.pricesMap.has(option._id)) {
			return numberToCurrency(this.pricesMap.get(option._id), this.currency);
		}
		if (this.optionGroup.displayIdentifiers.includes(DisplayIdentifier.sides)) {
			const minValue = Math.min(...this.optionGroup.articles.map(it => numberD(it.price)));
			const diffTo = numberD(option.price) - minValue;
			if (diffTo > 0) {
				return numberToCurrency(diffTo, this.currency);
			}
			return '';
		}
		let price = getPrice(option, OrderType.PREORDER, this.preorderType);
		if (this.fullPrice()) {
			price += getPrice(this.article, OrderType.PREORDER, this.preorderType);
		}
		return price > 0 ? numberToCurrency(price, this.currency) : '';
	}

	dependenciesRegardingOptionArticle(article: Article, groups: OptionGroup[], optionArticle: Article): OptionGroup[] {
		return article.groupDependencies
			.map(gd => {
				if (gd.dependencies.find(dependeci => dependeci.groupArticles.includes(optionArticle._id)) == null) {
					return null;
				} else {
					return groups.find(it => gd.group === it._id);
				}
			})
			.filter(it => !!it);
	}
	likeSotCalulation(option: Article) {
		// if (this.optionGroup.name.de.includes('Einzel oder Menü? SPLIT')) {
		if (this.optionGroup.displayIdentifiers.includes(DisplayIdentifier.menu)) {
			this.optionGroup.articles.forEach(it => {
				const price = (this.dependenciesRegardingOptionArticle(this.article, this.article.groups, it) ?? [])
					.map(option => {
						const arrayOfArticlesPriceInOption = option.articles.map(art => {
							return numberD(art.price);
						});
						const result = Math.min(...arrayOfArticlesPriceInOption) * option.requiredAmount;

						return result === Infinity || !result ? 0 : result;
					})
					.reduce((a, b) => a + b, 0);

				this.pricesMap.set(it._id, price);

				if (this.pricesMap.get(it._id) == null || this.pricesMap.get(it._id) == 0) {
					this.pricesMap.set(it._id, numberD(it.price) === Infinity ? 0 : numberD(it.price));
				}
			});
		}
	}
	fullPrice(): boolean {
		return (
			this.optionGroup.displayIdentifiers &&
			this.optionGroup.displayIdentifiers.findIndex(di => di === DisplayIdentifier.fullPrice) >= 0
		);
	}

	isOptionSelected(option: Article): boolean {
		return (
			this.selected.find(sel => sel.article._id === option._id && sel.group === this.optionGroup._id) !== undefined
		);
	}

	openInfoClick(option: Article) {
		this.openInfo.emit(option);
	}

	showMeasurement(article: Article) {
		if (article) {
			if (article?.measurement?.refAmount && article?.measurement?.refUnit) {
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'g') {
					return (
						'1' +
						' ' +
						'kg' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType) * 10, this.currency)
					);
				}
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'ml') {
					return (
						'1' +
						' ' +
						'l' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType) * 10, this.currency)
					);
				}
				return (
					article.measurement.refAmount +
					' ' +
					article.measurement.refUnit +
					' = ' +
					numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType), this.currency)
				);
			}
		} else {
			return '';
		}
	}

	checkPfandTag(article: Article) {
		if (article.tags?.length === 0) {
			return '';
		}
		const deposit25 = article.tags.find(it => it.identifier === 'deposit_25') ? 'deposit25' : '';
		const deposit15 = article.tags.find(it => it.identifier === 'deposit_15') ? 'deposit15' : '';
		const deposit8 = article.tags.find(it => it.identifier === 'deposit_8') ? 'deposit8' : '';

		return deposit15 || deposit25 || deposit8;
	}
}
